// extracted by mini-css-extract-plugin
export default {"title":"AdvancementReportListHeader__title___b_9Vn","icon":"AdvancementReportListHeader__icon___rraAv","hr":"AdvancementReportListHeader__hr___dp3vs"};